import TitleWithParagraph from './TitleWithParagraph'
export default TitleWithParagraph
